import axios from "axios";
import { REFUNDS_API_URL } from "../../../constants";

export const ACTIONS = {
    GET_OPTIONS_PRODUCT_LOADING: "GET_OPTIONS_PRODUCT_LOADING",
    GET_OPTIONS_PRODUCT_SUCCESS: "GET_OPTIONS_PRODUCT_SUCCESS",
    GET_OPTIONS_PRODUCT_ERROR: "GET_OPTIONS_PRODUCT_ERROR",
};

const getOptionsProducts = (opt_id) => {
    return async (dispatch) => {
        try {
            dispatch({
                type: ACTIONS.GET_OPTIONS_PRODUCT_LOADING,
            });

            const res = await axios.get(
                `${REFUNDS_API_URL}/options/${opt_id}`
            );
            if (res.status === 200) {
                dispatch({
                    type: ACTIONS.GET_OPTIONS_PRODUCT_SUCCESS,
                    payload: res.data,
                });
            }
        } catch (error) {
            dispatch({
                type: ACTIONS.GET_OPTIONS_PRODUCT_ERROR,
                payload: error.message,
            });
        }
    };
};

export default getOptionsProducts;
